import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import RouteLoadingFallback from './infrastructure/RouteLoadingFallback.js'

function Protected( {isAuthenticated, authChecked, children}) {
    const location = useLocation()
    if (!authChecked) {
        return <RouteLoadingFallback />
    }
    if (!isAuthenticated) {
        return <Navigate to="/loginWithGoogle" replace state={{ from: location.pathname + location.search }} />
    }
    return children
}

export default Protected
